/* Copyright (c) 2020 Lenderblock Corporation */

const blenderTransfersToPublicKey = '0x2b6b3a794e6bB6296466a284Bc8e92d74E13304B'
export default blenderTransfersToPublicKey;